import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    query: {
        method: 'GET',
        url: `${BASE_PATH_API}/eventHistory`
    },
    getByEntityId: {
        method: 'GET',
        url: `${BASE_PATH_API}/eventHistory/getByEntityId`
    },
    getEvents: {
        method: 'GET',
        url: `${BASE_PATH_API}/eventHistory/events`
    },
    getEventHistory: {
        method: 'GET',
        url: `${BASE_PATH_API}/eventHistory/grid`,
        params: {
            '$count': true
        }
    },
    deleteEventHistory: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/eventHistory`
    },
    createEventHistory: {
        method: 'POST',
        url: `${BASE_PATH_API}/eventHistory`
    },
    updateEventHistory: {
        method: 'PUT',
        url: `${BASE_PATH_API}/eventHistory`
    },
    getEventHistoryById: {
        method: 'GET',
        url: `${BASE_PATH_API}/eventHistory/:id`
    }
};

export function EventHistoryApi(
    $httpParamSerializer
) {
    const service = createActions(actions);

    service.getEventHistoryExportUrl = function getEventHistoryExportUrl(params) {
        return `${BASE_PATH_API}/eventHistory/export?${$httpParamSerializer(params)}`;
    };

    return service;
}
EventHistoryApi.$inject = [
    '$httpParamSerializer'
];
